import type { SVGProps } from 'react';
const SvgDashboardCustomize = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="0.75em"
    height="0.75em"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <g clipPath="url(#dashboard_customize_svg__a)">
      <path
        fill="currentColor"
        d="M3 3h8v8H3V3Zm10 0h8v8h-8V3ZM3 13h8v8H3v-8Zm15 0h-2v3h-3v2h3v3h2v-3h3v-2h-3v-3Z"
      />
    </g>
    <defs>
      <clipPath id="dashboard_customize_svg__a">
        <path fill="currentColor" d="M0 0h24v24H0z" />
      </clipPath>
    </defs>
  </svg>
);
export default SvgDashboardCustomize;
